import React, { useEffect } from "react";

export function LoginRouter() {
    useEffect(() => {
        window.location.assign("/login");
    }, []);

    return <></>;
}
